import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GoalCollectionResponseDto } from '../dto/response/goal-collection-response.dto';
import goalCollectionService from '../services/goal-collection.service';
import { GoalCollectionSaveRequestDto } from '../dto/request/goal-collection-save-request.dto';
// import { GoalCollectionUpdateRequestDto } from '../dto/request/goal-collection-update-request.dto';

const initialState = {
  status: 'idle',
  goalCollections: [] as GoalCollectionResponseDto[] | null,
  filteredGoalCollections: [] as GoalCollectionResponseDto[] | null,
  goalCollection: {} as GoalCollectionResponseDto | null,
  error: null as string | null,
};

// export const fetchGoalCollections = createAsyncThunk(
//   'goalCollection/fetchGoalCollections',
//   async () => {
//     return await goalCollectionService.fetchGoalCollections();
//   }
// );

// export const fetchGoalCollectionById = createAsyncThunk(
//   'goalCollection/fetchGoalCollectionById',
//   async (id: string) => {
//     return await goalCollectionService.fetchGoalCollectionById(id);
//   }
// );

export const fetchGoalCollectionsByGoalId = createAsyncThunk(
  'goalCollection/fetchGoalCollectionsByGoalId',
  async (goalId: string) => {
    return await goalCollectionService.fetchGoalCollectionsByGoalId(goalId);
  }
);

export const createGoalCollection = createAsyncThunk(
  'goalCollection/createGoalCollection',
  async (saveRequest: GoalCollectionSaveRequestDto) => {
    return await goalCollectionService.createGoalCollection(saveRequest);
  }
);

// export const updateGoalCollection = createAsyncThunk(
//   'goalCollection/updateGoalCollection',
//   async (updateRequest: GoalCollectionUpdateRequestDto) => {
//     return await goalCollectionService.updateGoalCollection(updateRequest);
//   }
// );

export const deleteGoalCollection = createAsyncThunk(
  'goalCollection/deleteGoalCollection',
  async (existingId: string) => {
    return await goalCollectionService.deleteGoalCollection(existingId);
  }
);

const goalCollectionSlice = createSlice({
  name: 'goalCollectionSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchGoalCollections.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchGoalCollections.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.goalCollections = action.payload;
      // })
      // .addCase(fetchGoalCollections.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      // .addCase(fetchGoalCollectionById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchGoalCollectionById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.goalCollection = action.payload;
      // })
      // .addCase(fetchGoalCollectionById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(fetchGoalCollectionsByGoalId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchGoalCollectionsByGoalId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.filteredGoalCollections = action.payload;
      })
      .addCase(fetchGoalCollectionsByGoalId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(createGoalCollection.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createGoalCollection.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.goalCollections?.push(action.payload);
      })
      .addCase(createGoalCollection.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(updateGoalCollection.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateGoalCollection.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   if (state.goalCollections) {
      //     const goalCollectionIndex = state.goalCollections.findIndex(
      //       (goalCollection) => goalCollection.id === action.payload.id
      //     );
      //     if (goalCollectionIndex !== -1) {
      //       state.goalCollections[goalCollectionIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateGoalCollection.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(deleteGoalCollection.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteGoalCollection.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteGoalCollection.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default goalCollectionSlice.reducer;
